export const POPULAR =[
    {
        id: 1 ,
        name:'BOND',
        price:'200',
        img1:require('../asset/rb/1bond1-rb.png'),
        img2:require('../asset/rb/1bond2-rb.png'),
        desc:'The Bond dining chair ensures that the dining room will be trendier. Its main attraction lies in the backrest design, where the materials combination makes it more appealing. There are two layers different in sizes and shapes, composing the main structure, which is adorned by an elegant vertical feature in rattan, and framed with walnut wood, giving it a bold touch',
        material:'Matte Walnut Wood, Fabric, Polished Brass and Rattan',
        weight:'12 kg | 26,46 lbs',
        categori:'DINING CHAIR',
    },
    {
        id: 2 ,
        name:'ASHBY',
        price:'275',
        img1:require('../asset/rb/2ashby-rb.png'),
        img2:require('../asset/rb/2ashby2-rb.png'),
        desc:'The Ashby dining chair is a portrayal of the mid-century vibe with bold shapes and colours. This dining chair was thought to give a special touch to your dining room.',
        material:' Matte Walnut Wood, Fabric and Polished Brass.',
        weight:'7 kg | 15,43 lbs',
        categori:'DINING CHAIR',
    },
    {
        id: 3 ,
        name:'RETRO MORYSON',
        price:'700',
        img1:require('../asset/rb/3retrom-rb.png'),
        img2:require('../asset/rb/3retrom2-rb.png'),
        desc:'With a vintage style, the Retro Moryson Sideboard rises as a recreation from the Moryson Sideboard. Inspired by the mid-century retro design, this distinctive piece promises to give a stylish touch to any living room. Using a tubular gold plated brass frame structure as support, harmoniously blended with lacquered trendy colors.',
        material:'Matte Walnut Wood, Glossy Lacquered Wood and Gold Plated Brass.',
        weight:'140 kg | 308,64 lbs',
        categori:'SIDEBOARD',
        subCategori:'SIDEBOARD',
    },
    {
        id: 4 ,
        name:'HOLLY',
        price:'875',
        img1:require('../asset/rb/4holly-rb.png'),
        img2:require('../asset/rb/4holly2-rb.png'),
        desc:'Drawing inspiration from the golden years aesthetic, Holly’s retro look brings to the modern interiors a bold elegance emphasized by the exquisite brass structure holding the robust body. Its alluring design will be the spotlight of any space.',
        material:'Matte Walnut Wood and Gold Plated Brass',
        weight:'180 kg | 396,83 lbs',
        categori:'SIDEBOARD',
        subCategori:'SIDEBOARD',
    },
]